import { Action } from '@ngrx/store';
import { InternetPasswordModel } from '@dch/products-business-logic/src/shared/models/internet-settings-password.model';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const GET_MODEM_SAFETY = 'GET_MODEM_SAFETY';
export const GET_MODEM_SAFETY_SUCCESS = 'GET_MODEM_SAFETY_SUCCESS';
export const GET_MODEM_SAFETY_FAILURE = 'GET_MODEM_SAFETY_FAILURE';
export const UPDATE_MODEM_SAFETY = 'UPDATE_MODEM_SAFETY';
export const UPDATE_MODEM_SAFETY_SUCCESS = 'UPDATE_MODEM_SAFETY_SUCCESS';
export const UPDATE_MODEM_SAFETY_FAILURE = 'UPDATE_MODEM_SAFETY_FAILURE';
export const UPDATE_SHARED_IP = 'UPDATE_SHARED_IP';
export const UPDATE_SHARED_IP_SUCCESS = 'UPDATE_SHARED_IP_SUCCESS';
export const UPDATE_SHARED_IP_FAILURE = 'UPDATE_SHARED_IP_FAILURE';
export const UPDATE_MAC_IP_ADDRESS = 'UPDATE_MAC_IP_ADDRESS';
export const UPDATE_MAC_IP_ADDRESS_SUCCESS = 'UPDATE_MAC_IP_ADDRESS_SUCCESS';
export const UPDATE_MAC_IP_ADDRESS_FAILURE = 'UPDATE_MAC_IP_ADDRESS_FAILURE';
export const ADD_MAC_IP_ADDRESS_SUCCESS = 'ADD_MAC_IP_ADDRESS_SUCCESS';
export const ADD_MAC_IP_ADDRESS_FAILURE = 'ADD_MAC_IP_ADDRESS_FAILURE';
export const ADD_MAC_IP_ADDRESS = 'ADD_MAC_IP_ADDRESS';
export const DELETE_MAC_IP_ADDRESS = 'DELETE_MAC_IP_ADDRESS';
export const DELETE_MAC_IP_ADDRESS_SUCCESS = 'DELETE_MAC_IP_ADDRESS_SUCCESS';
export const DELETE_MAC_IP_ADDRESS_FAILURE = 'DELETE_MAC_IP_ADDRESS_FAILURE';
export const GET_MAC_IP_ADDRESS = 'GET_MAC_IP_ADDRESS';
export const GET_MAC_IP_ADDRESS_SUCCESS = 'GET_MAC_IP_ADDRESS_SUCCESS';
export const GET_MAC_IP_ADDRESS_FAILURE = 'GET_MAC_IP_ADDRESS_FAILURE';
export const GET_WIFI_SSID = 'GET_WIFI_SSID';
export const GET_WIFI_SSID_SUCCESS = 'GET_WIFI_SSID_SUCCESS';
export const GET_WIFI_SSID_FAILURE = 'GET_WIFI_SSID_FAILURE';
export const UPDATE_WIFI_SSID = 'UPDATE_WIFI_SSID';
export const UPDATE_WIFI_SSID_SUCCESS = 'UPDATE_WIFI_SSID_SUCCESS';
export const UPDATE_WIFI_SSID_FAILURE = 'UPDATE_WIFI_SSID_FAILURE';

export class UpdatePassword implements Action {
  type: string = UPDATE_PASSWORD;

  constructor(public payload: InternetPasswordModel) {}
}

export class UpdatePasswordFailed implements Action {
  type = UPDATE_PASSWORD_FAILED;

  constructor(public payload: any) {}
}

export class UpdatePasswordSuccess implements Action {
  type = UPDATE_PASSWORD_SUCCESS;

  constructor(public payload: any) {}
}

export class GetModemSafetySettings implements Action {
  type: string = GET_MODEM_SAFETY;

  constructor(public payload: string) {}
}

export class GetModemSafetySettingsSuccess implements Action {
  type: string = GET_MODEM_SAFETY_SUCCESS;

  constructor(public payload: any) {}
}

export class GetModemSafetySettingsFailure implements Action {
  type: string = GET_MODEM_SAFETY_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateModemSafetySettings implements Action {
  type: string = UPDATE_MODEM_SAFETY;

  constructor(public payload: any) {}
}

export class UpdateModemSafetySettingsSuccess implements Action {
  type: string = UPDATE_MODEM_SAFETY_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateModemSafetySettingsFailure implements Action {
  type: string = UPDATE_MODEM_SAFETY_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateSharedIpSettings implements Action {
  type: string = UPDATE_SHARED_IP;

  constructor(public payload: string) {}
}

export class UpdateSharedIpSettingsSuccess implements Action {
  type: string = UPDATE_SHARED_IP_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateSharedIpSettingsFailure implements Action {
  type: string = UPDATE_SHARED_IP_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateMacIpAddress implements Action {
  type: string = UPDATE_MAC_IP_ADDRESS;

  constructor(public payload: any) {}
}

export class UpdateMacIpAddressSuccess implements Action {
  type: string = UPDATE_MAC_IP_ADDRESS_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateMacIpAddressFailure implements Action {
  type: string = UPDATE_MAC_IP_ADDRESS_FAILURE;

  constructor(public payload: any) {}
}

export class DeleteMacIpAddress implements Action {
  type: string = DELETE_MAC_IP_ADDRESS;

  constructor(public payload: string) {}
}

export class DeleteMacIpAddressSuccess implements Action {
  type: string = DELETE_MAC_IP_ADDRESS_SUCCESS;

  constructor(public payload: any) {}
}

export class DeleteMacIpAddressFailure implements Action {
  type: string = DELETE_MAC_IP_ADDRESS_FAILURE;

  constructor(public payload: any) {}
}

export class GetMacIpAddress implements Action {
  type: string = GET_MAC_IP_ADDRESS;

  constructor(public payload: string) {}
}

export class GetMacIpAddressSuccess implements Action {
  type: string = GET_MAC_IP_ADDRESS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetMacIpAddressFailure implements Action {
  type: string = GET_MAC_IP_ADDRESS_FAILURE;

  constructor(public payload: any) {}
}

export class AddMacIpAddress implements Action {
  type: string = ADD_MAC_IP_ADDRESS;

  constructor(public payload: any) {}
}

export class AddMacIpAddressSuccess implements Action {
  type: string = ADD_MAC_IP_ADDRESS_SUCCESS;

  constructor(public payload: any) {}
}

export class AddMacIpAddressFailure implements Action {
  type: string = ADD_MAC_IP_ADDRESS_FAILURE;

  constructor(public payload: any) {}
}

export class GetWifiSsid implements Action {
  type: string = GET_WIFI_SSID;

  constructor(public payload: string) {}
}

export class GetWifiSsidSuccess implements Action {
  type: string = GET_WIFI_SSID_SUCCESS;

  constructor(public payload: any) {}
}

export class GetWifiSsidFailure implements Action {
  type: string = GET_WIFI_SSID_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateWifiSsid implements Action {
  type: string = UPDATE_WIFI_SSID;

  constructor(public payload: any) {}
}

export class UpdateWifiSsidSuccess implements Action {
  type: string = UPDATE_WIFI_SSID_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateWifiSsidFailure implements Action {
  type: string = UPDATE_WIFI_SSID_FAILURE;

  constructor(public payload: any) {}
}

export type Actions =
  | UpdatePassword
  | UpdatePasswordFailed
  | UpdatePasswordSuccess
  | GetModemSafetySettings
  | GetModemSafetySettingsSuccess
  | GetModemSafetySettingsFailure
  | UpdateModemSafetySettings
  | UpdateModemSafetySettingsSuccess
  | UpdateModemSafetySettingsFailure
  | UpdateSharedIpSettings
  | UpdateSharedIpSettingsSuccess
  | UpdateSharedIpSettingsFailure
  | UpdateMacIpAddress
  | UpdateMacIpAddressSuccess
  | UpdateMacIpAddressFailure
  | GetMacIpAddress
  | GetMacIpAddressSuccess
  | GetMacIpAddressFailure
  | AddMacIpAddress
  | AddMacIpAddressSuccess
  | AddMacIpAddressFailure
  | DeleteMacIpAddress
  | DeleteMacIpAddressSuccess
  | DeleteMacIpAddressFailure
  | GetWifiSsid
  | GetWifiSsidSuccess
  | GetWifiSsidFailure
  | UpdateWifiSsid
  | UpdateWifiSsidSuccess
  | UpdateWifiSsidFailure;
